import { IonFooter, IonIcon, IonModal, IonText, useIonRouter } from "@ionic/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { usePostHog } from "posthog-js/react";
import { Button } from "@/components/Global/Button";
import { Toolbar } from "@/components/Global/Toolbar";
import { useReflection } from "@/lib/hooks/useReflection";
import { sparklesIcon } from "@/lib/icons/@heroicons/react/24/outline";
import { Routes } from "@/lib/router";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ModalReflectionQuestionCompleted() {
	const { t } = useTranslation();
	const router = useIonRouter();
	const modalRef = useRef<HTMLIonModalElement>(null);
	const posthog = usePostHog();
	const modal = useSelectorModalStore.use.reflectionQuestionCompleted();
	const present = useSelectorModalStore.use.present();
	const dismiss = useSelectorModalStore.use.dismiss();
	const { service: reflectionService } = useReflection();
	const { id: currentId } = Routes.ReflectionQuestion.useParams();

	return (
		<IonModal
			ref={modalRef}
			isOpen={modal.isOpen}
			onWillPresent={() => {
				present("reflectionQuestionCompleted");
				posthog.capture("Modal Reflection Question Completed Present");
			}}
			onWillDismiss={() => {
				dismiss("reflectionQuestionCompleted", {
					newSelectedCoreValues: [],
					updatedSelectedCoreValues: [],
				});
				posthog.capture("Modal Reflection Question Completed Dismiss");
			}}
			onDidDismiss={() => {
				if (reflectionService) {
					router.push(reflectionService?.router.nextQuestion(currentId), "back");
				}
			}}
			initialBreakpoint={1}
			breakpoints={[0, 1]}
			handle={false}
			className="ion-min-h-[600px] ion-rounded-4xl ion-h-min"
		>
			<div className="p-4">
				<IonText className="text-brown-700 text-2xl font-bold">
					{t("modal.reflection.question.completed.title")}
				</IonText>
				<div className="space-y-2 pt-4">
					{modal.updatedSelectedCoreValues?.map((coreValue) => (
						<div
							key={coreValue.id}
							className="text-md text-brown-700 flex items-center justify-between rounded-xl bg-white p-4 font-semibold"
						>
							<p>
								{coreValue.coreValue.emoji} {coreValue.coreValue.name}
							</p>
						</div>
					))}
					{modal.newSelectedCoreValues?.map((coreValue) => (
						<div
							key={coreValue.id}
							className="text-md text-brown-700 flex items-center justify-between rounded-xl bg-white p-4 font-semibold"
						>
							<p>
								{coreValue.coreValue.emoji} {coreValue.coreValue.name}
							</p>
							<div className="flex items-center gap-1">
								<IonIcon icon={sparklesIcon} className="text-brown-400" />
							</div>
						</div>
					))}
				</div>
			</div>

			<IonFooter className="ion-no-border">
				<Toolbar className="ion-bg-brown-200 ion-p-4">
					<div className="flex flex-col gap-2">
						<Button
							data-attr="modal.reflection.question.completed.confirm"
							expand="block"
							variant="primary"
							onClick={() => {
								modalRef.current?.dismiss();
							}}
						>
							{t("modal.reflection.question.completed.confirm")}
						</Button>
					</div>
				</Toolbar>
			</IonFooter>
		</IonModal>
	);
}
